<template>

    <div class="container card p-5 shadow m-auto">
        
        <h1>Reorder Category </h1>
        <hr>
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <ul>
            <li>Move the pointer to the desired category in the list</li>
            <li>Press, and hold down, the button on the mouse to "grab" the desired category</li>
            <li>"Drag" the category to the desired location by moving the pointer to this one</li>
            <li>"Drop" the category by releasing the button</li>
        </ul>
        

        
        <draggable 
            :list="filteredCategories" 
            v-bind="dragOptions"
            class="list-group mb-3"
            ghost-class="ghost"
            tag="ul">
            <transition-group type="transition" name="flip-list">
                <li class="list-group-item" v-for="element in filteredCategories" :key="element.id">
                    <i :class=" element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                       @click="element.fixed = !element.fixed"
                       aria-hidden="true">
                    </i>
                    {{element.title}} 
                    <icon style="float: right;" icon="arrows-alt" />
                </li>
        
            </transition-group>
        </draggable>

        <div class="row m-0 p-0">
            <button @click="reorderCategories()" type="button" class="btn btn-primary mb-3 w-auto d-block">Reorder Categories</button>
        </div>

        
    </div>

</template>

<script>
import draggable from 'vuedraggable';
export default {
    data() {
        return {
            categories: [],
            response: {}
        }
    },
    methods: {
        loadCategories: function() {
            let self = this;
            this.$http.get('/api/categories/get-all')
            .then(response => {
                self.categories = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        reorderCategories: function() {
            let self = this;
            this.$http.put('/api/categories/reorder', this.categories)
            .then(response => {
                
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    mounted: function() {
        this.loadCategories();
    },
    watch: {
        response: function(val){
            if(val.success === true)
            {
                setTimeout(() => {this.$router.push("/admin/categories");}, 1000)
            }
            setTimeout(() => {this.response.success = null}, 3000)
        }
    },
    components: {
            draggable,
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
        filteredCategories() {
            try {
                let self = this;
                return this.categories.filter(function (obj) {
                    return obj.languageId == self.$store.getters.selectedLanguage.id;
                });
            }
            catch {
                return [];
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>